'use strict';

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var addAll = require('./add-all.js');

var last = require('it-last');

var configure = require('./lib/configure.js');

var normaliseInputSingle = require('ipfs-core-utils/files/normalise-input-single');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

function createAdd(options) {
  var all = addAll.createAddAll(options);
  return configure.configure(function () {
    function add(_x) {
      return _add.apply(this, arguments);
    }

    function _add() {
      _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var options,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return last__default["default"](all(normaliseInputSingle.normaliseInput(input), options));

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _add.apply(this, arguments);
    }

    return add;
  })(options);
}

exports.createAdd = createAdd;